<template>
    <v-row class="px-0 banners">
        <v-col cols="12" md="12">
            <v-card-subtitle class="title px-0 mx-0">{{ $t('mainStore.personalize.banners.title') }}</v-card-subtitle>
            <div class="d-flex align-strech flex-wrap">
                <v-card width="250" class="white lighten-3 mr-6 mb-3" v-for="banner in documents" :style="`background-image: url(${banner.urlBackground}); background-color: #fff; background-size: cover`" :key="banner.id">
                    <div class="d-flex justify-space-between pa-1" style="position: absolute; z-index: 3; width: 100%">
                        <div>
                            <v-chip label color="success" v-if="banner.status">{{ $t('common.active') }}</v-chip>
                            <v-chip label color="error" v-if="!banner.status">{{ $t('common.inactive') }}</v-chip>
                            <v-chip label color="primary" v-if="banner.isModal">Full banner</v-chip>
                        </div>
                        <div v-if="caducaEn(banner)">
                            <v-chip label class="text-caption pa-3">{{ caducaEn(banner) }}</v-chip>
                        </div>
                        <v-menu bottom left>
                            <template v-slot:activator="{ on, attrs }">
                                <v-chip class="px-1" label v-bind="attrs" v-on="on" color="grey" outlined><v-icon
                                        color="black">mdi-dots-vertical</v-icon></v-chip>
                            </template>

                            <v-list>
                                <v-list-item>
                                    <v-list-item-title
                                        @click="edit(banner)"><v-icon>mdi-pencil-outline</v-icon></v-list-item-title>
                                </v-list-item>
                                <v-list-item>
                                    <v-list-item-title
                                        @click="remove(banner)"><v-icon>mdi-trash-can-outline</v-icon></v-list-item-title>
                                </v-list-item>
                            </v-list>
                        </v-menu>
                    </div>

                    <v-img width="100%" cover height="160" :src="banner.url"></v-img>
                    <v-card style="position: absolute; bottom: 0" class="ma-1 pa-1">
                        <div class="text-caption text-center">
                            {{ banner.title }}
                        </div>
                    </v-card>
                </v-card>


                <v-card width="250" elevation="0" min-height="120"
                    class="white lighten-3 mr-6 d-flex align-center justify-center" color="grey lighten-3"
                    @click="add()">
                    <div>
                        <div class="d-flex justify-center">
                            <v-icon class="black--text mx-auto" x-large>mdi-plus-circle-outline</v-icon>
                        </div>
                        <v-card-title class="title text-center pb-0 mb-0">{{
                            $t('mainStore.personalize.banners.addBanner')
                            }}</v-card-title>
                    </div>
                </v-card>
            </div> 
        </v-col>
        <v-dialog v-model="show" width="768">
            <v-card class="mx-auto">
                <v-card-title class="d-flex justify-space-between">{{
                    $t('mainStore.personalize.banners.dialogTitle') }}<v-btn icon color="grey"
                        @click="cancel()"><v-icon>mdi-close</v-icon></v-btn></v-card-title>
                <v-card-text>
                    <form>
                        <v-text-field @input="v$.form.title.$touch()" @blur="v$.form.title.$touch()"
                            :errorMessages="titleErrors" v-model="form.title"
                            :label="$t('mainStore.personalize.banners.logoTitle')"></v-text-field>

                        <!-- <v-select v-model="form.type" :items="types" item-text="text" item-value="value"></v-select> -->
                        <v-text-field v-model="form.button.url"
                            :label="$t('mainStore.personalize.banners.linkTitle')"></v-text-field>
                        <!-- <v-switch v-model="form.button.active" v-if="form.type == 'text'"
                        :label="form.button.active ? `Link solo en el botón` : `Link en imagen completa`"></v-switch> -->
                        <!-- <v-text-field v-if="form.button.active" v-model="form.button.text"
                        label="Texto en botón"></v-text-field> -->


                        <!-- <v-textarea v-if="form.type != 'image'" v-model="form.text" label="Texto"></v-textarea> -->
                        <v-switch v-model="form.hasValidate"
                            :label="form.hasValidate ? this.$t('mainStore.personalize.banners.expires') : this.$t('mainStore.personalize.banners.noExpires')"></v-switch>
                        <v-menu v-if="form.hasValidate">
                            <template v-slot:activator="{ on, attrs }">

                                <v-text-field :label="$t('mainStore.personalize.banners.calendarLabel')" readonly
                                    v-model="formatedDate" v-bind="attrs" v-on="on"
                                    append-icon="mdi-calendar"></v-text-field>

                            </template>
                            <v-date-picker v-model="form.dueDate"></v-date-picker>
                        </v-menu>
                        <v-text-field v-model="form.position" label="Posição (por prioridade)"></v-text-field>

                        <v-switch v-model="form.status"
                            :label="form.status ? $t('mainStore.personalize.banners.active') : $t('mainStore.personalize.banners.inactive')"></v-switch>

                        <v-switch v-model="form.isModal"
                            :label="form.isModal ? $t('mainStore.personalize.banners.isModal') : $t('mainStore.personalize.banners.isModal')"></v-switch>
                        <template v-if="show">
                            <v-alert type="info" outlined>
                                {{ form.isModal ? $t('mainStore.personalize.banners.alertIsModal') : $t('mainStore.personalize.banners.alert') }}
                            </v-alert>
                            <template v-if="selectedStore.options.slidesFullWidth">
                                <span>Background</span>
                                <Upload :view="'image'" :path="'/whitelabel-banners/background/'" @set-upload="updateImages($event, 'urlBackground')"
                                    :snap="form.urlBackground ? [form.urlBackground] : []" :unique="true" :sample="true"></Upload>
                            </template>
                            <span>Desktop</span>
                            <Upload :view="'image'" :path="'/whitelabel-banners/desktop/'" @set-upload="updateImages($event, 'url')"
                                :snap="form.url ? [form.url] : []" :unique="true" :sample="true"></Upload>
                            
                            
                        <span>Mobile</span>
                        <v-alert type="info" outlined>
                                {{ $t('mainStore.personalize.banners.alertMobile') }}
                            </v-alert>
                        <Upload :view="'image'" :path="'/whitelabel-banners/mobile/'" @set-upload="updateImages($event, 'urlMobile')"
                                :snap="form.urlMobile ? [form.urlMobile] : []" :unique="true" :sample="true"></Upload>


                            <div class="red--text body-2" v-for="error in logoErrors" :key="error">{{error}}</div>
                        </template>
                    </form>
                </v-card-text>
                <v-card-actions class="d-flex justify-end pa-4">
                    <v-btn text @click="cancel()">{{ $t('mainStore.personalize.banners.cancel') }}</v-btn>
                    <v-btn @click="save()" color="success" elevation="0" :loading="processing">{{
                        $t('mainStore.personalize.banners.save') }}</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-dialog v-model="toDelete" width="480">
            <v-card class="mx-auto">
                <v-card-title class="d-flex justify-space-between">{{
                    $t('mainStore.personalize.banners.deleteTitle') }}<v-btn icon color="grey"
                        @click="toDelete = false"><v-icon>mdi-close</v-icon></v-btn></v-card-title>
                <v-card-subtitle>{{ $t('mainStore.personalize.banners.deleteSubTitle') }}
                </v-card-subtitle>
                <v-card-actions class="d-flex justify-end pa-4">
                    <v-btn text @click="toDelete = false">{{ $t('mainStore.personalize.banners.cancel') }}</v-btn>
                    <v-btn @click="removeBanner()" color="error" elevation="0">{{ $t('common.delete') }}</v-btn>
                </v-card-actions>
            </v-card>

        </v-dialog>
    </v-row>
</template>
<script>
import moment from 'moment'
import config from '@/store/config'
import useVuelidate from "@vuelidate/core";
import { required, numeric, minLength, maxLength } from "@vuelidate/validators";

// import { getAuth, onAuthStateChanged, signOut } from "firebase/auth";
import { initializeApp } from "firebase/app";

import { getFirestore, collection, query, where, getDocs, setDoc, doc, deleteDoc } from "firebase/firestore";
// import Upload from "@/interface/FireUpload.vue"
import Upload from '../../interface/FileUpload.vue';

import { mapState, mapActions } from "vuex";

export default {
    name: "BannersSection",


    setup() {
        return { v$: useVuelidate() };
    },

    validations() {
        return {
            form: {
                title: { required, minLength: minLength(2), maxLength: maxLength(100) },
                url: { required },
            },
        };
    },

    components: {
        Upload
    },
    data: () => ({
        processing: false,
        loading: true,
        documents: [],
        toDelete: false,
        saved: false,
        removed: false,
        removeSnap: null,
        types: [{ text: 'Imagen', value: 'image' }, { text: 'Imagen y texto', value: 'text-image' }],
        show: false,
        form: {
            position: 1,
            dueDate: null,
            hasValidate: false,
            url: "",
            status: true,
            button: {
                active: false,
                text: "",
                url: ""
            },
            store: null,
            text: "",
            id: "",
            type: "image"
        },
        snap: {
            dueDate: null,
            hasValidate: true,
            url: "",
            status: true,
            button: {
                active: false,
                text: "",
                url: ""
            },
            store: null,
            text: "",
            id: "",
            type: "image"
        },
    }),
    mounted() {
        this.form.store = this.selectedStore.id
        this.loadDocuments()
    },
    watch: {
        'selectedStore': {
            deep: true,
            haldler() {
                this.loadDocuments()
            }
        },
        'form': {
            handler(e){
                console.log('Novo valor:', e)
            }
        }
    },

    computed: {
        ...mapState("groupStores", [
            "selectedStore",
        ]),
        formatedDate() {
            if (!this.form.dueDate) return '-'
            return moment(this.form.dueDate, 'YYYY-MM-DD').format('LL')
        },

        titleErrors() {
            const errors = [];
            if (!this.v$.form.title.$dirty) return errors;
            this.v$.form.title.minLength.$invalid &&
                errors.push(
                    this.$t("allStores.err.minLengthName", {
                        count: 2,
                    })
                );
            this.v$.form.title.maxLength.$invalid &&
                errors.push(
                    this.$t("allStores.err.maxLengthName", {
                        count: 100,
                    })
                );
            this.v$.form.title.required.$invalid &&
                errors.push(this.$t("allStores.err.requiredName"));
            return errors;
        },

        logoErrors() {
            if (!this.v$.form.url.$dirty) return errors;
            const errors = [];
            this.v$.form.url.required.$invalid &&
                errors.push(this.$t("allStores.err.requiredLogo"));
            return errors;
        },

    },
    methods: {

        ...mapActions("snackbar", [
            "showSnack",
        ]),
        updateImages(e, k) {
            console.log('e', e)
            if(e.length)
            this.form[k] = e[0].url
            // this.form.files = f
        },
        caducaEn(disclaimer) {
            if (disclaimer.hasOwnProperty('hasValidate') && disclaimer.hasValidate) {
                return moment(disclaimer.dueDate, 'YYYY-MM-DD').fromNow();
            }
            else {
                return null
            }
        },
        add() {
            this.show = true
        },
        cancel() {
            this.show = false
            const form = JSON.parse(JSON.stringify(this.snap))
            if (!form.hasOwnProperty('position'))
                form.position = 1

            this.form = form

        },
        remove(item) {
            this.removeSnap = item
            this.toDelete = true
        },
        removeBanner() {
            const firebase = initializeApp(config)
            const db = getFirestore(firebase);
            deleteDoc(doc(db, "slides", this.removeSnap.id)).then((res) => {
                this.toDelete = false
                this.showSnack({
                    text: this.$t("mainStore.personalize.banners.snackMsgErr"),
                    color: "success",
                    timeout: 3800,
                    icon: "mdi-check",
                });
                // this.removed = true
                this.loadDocuments()
            });
        },
        edit(banner) {
            this.form = JSON.parse(JSON.stringify(banner))
            this.show = true
        },

        loadDocuments() {
            this.loading = true
            const firebase = initializeApp(config)
            const db = getFirestore(firebase);
            const q = query(collection(db, "slides"));
            const querySnapshot = getDocs(q);
            const documents = []
            querySnapshot.then((docs) => {
                docs.forEach((doc) => {
                    const data = doc.data()
                    if (!data.hasOwnProperty('dueDate'))
                        data.dueDate = null
                    if (!data.hasOwnProperty('hasValidate'))
                        data.hasValidate = false
                    if (data.store == this.selectedStore.id) {
                        documents.push(data)
                    }

                })
                this.documents = documents
                this.loading = false
            })
        },
        save() {
            this.v$.$touch()
            if (!this.v$.$invalid) {
                let SecForm = []
                this.processing = true
                const Form = this.form
                if (this.form.id) {
                    Form.createdOn = moment().format()
                }

                else {
                    Form.updatedOn = moment().format()
                }
                if(Form.isModal){
                     SecForm = this.documents.filter(doc => doc.isModal && doc.id != Form.id)
                     console.log('SecForm', SecForm)
                    if(SecForm.length)
                        SecForm[0].isModal = false
                }
                Form.id = this.form.id ? this.form.id : `sli${moment().format('X')}`
                console.log('F O R M', Form)
                //console.log(Form)
                const firebase = initializeApp(config)
                const db = getFirestore(firebase)
                setDoc(doc(db, "slides", Form.id), Form).then(() => {
                    
                    if(SecForm.length)
                        SecForm.forEach((formSec, formSecIndex) => {
                    console.log('formSec', formSec)
                    console.log('formSecIndex', formSecIndex)
                            setDoc(doc(db, 'slides', formSec.id), formSec).then(() => {

                                if(formSecIndex == (SecForm.length - 1)){
                                    console.log('SecForm.length', SecForm.length)
                                    this.returnResult() 
                                }
                            })
                        })
                    else
                        this.returnResult()
                    // this.saved = true

                    this.loadDocuments()
                });
            }

        },
        returnResult(){
            this.show = false
            this.processing = false
            this.form = JSON.parse(JSON.stringify(this.snap))
            this.form.store = this.selectedStore.id
            this.showSnack({
                text: this.$t("mainStore.personalize.banners.snackMsgSucess"),
                color: "success",
                timeout: 3800,
                icon: "mdi-check",
            });
        }
    }

}
</script>
<style>
.banners .v-card {
    overflow: hidden;
}
</style>